export default "__VITE_ASSET__pbtjMUWk__"